import React from 'react';

export const AlertIcon = React.forwardRef(function Compliance(
  props: React.ComponentProps<'svg'>,
  ref: React.ForwardedRef<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      stroke="currentColor"
      {...props}
      ref={ref}
      strokeWidth="2"
    >
      <g id="Outline">
        <path d="m47.043 18.417a1 1 0 0 0 -1.188 1.609 7.858 7.858 0 0 1 3.005 4.628 1 1 0 0 0 .976.784 1.014 1.014 0 0 0 .217-.023 1 1 0 0 0 .76-1.192 9.86 9.86 0 0 0 -3.77-5.806z" />
        <path d="m54.837 25.612h.1a1 1 0 0 0 .9-1.091 14 14 0 0 0 -7.015-10.8 1 1 0 1 0 -.988 1.74 12 12 0 0 1 6.013 9.257 1 1 0 0 0 .99.894z" />
        <path d="m59.73 25.785h.032a1 1 0 0 0 .969-1.03 17.887 17.887 0 0 0 -10.139-15.614 1 1 0 1 0 -.869 1.8 15.894 15.894 0 0 1 9.008 13.874 1 1 0 0 0 .999.97z" />
        <path d="m61.342 51.509-24.995-43.96a5 5 0 0 0 -8.694 0l-24.995 43.96a5 5 0 0 0 4.347 7.471h49.995a5 5 0 0 0 4.347-7.471zm-1.754 3.98a2.97 2.97 0 0 1 -2.588 1.491h-49.995a3 3 0 0 1 -2.605-4.48l25-43.96a3 3 0 0 1 5.216 0l25 43.96a2.97 2.97 0 0 1 -.028 2.989z" />
        <path d="m32 16a4.955 4.955 0 0 0 -4.935 5.393l1.579 19.541a3.373 3.373 0 0 0 6.719-.011l1.574-19.523a4.954 4.954 0 0 0 -4.937-5.4zm1.37 24.752a1.373 1.373 0 0 1 -2.733.011l-1.579-19.54a2.957 2.957 0 1 1 5.889.009z" />
        <path d="m32 46a4 4 0 1 0 4 4 4 4 0 0 0 -4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z" />
      </g>
    </svg>
  );
});
